export const csLoader = ({ src, ...params }) => {
  let url = src;
  let added = false;

  if (params) {
    for (const option in params) {
      if (params[option]) {
        url += `${added ? '&' : '?'}${option}=${params[option]}`;
        added = true;
      }
    }
  }

  return url;
};
